import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Restriction } from '../../../api/entities/api-query.entity';
import { RecordId } from '../../entities/metadata/metadata.entity';
import { RestrictionType } from '../../entities/restrictions/restriction-types.entity';
import { ShRecordRestrictionService } from '../../services/restrictions/record-restriction.service';

@Injectable({ providedIn: 'root' })
/**
 * Inject restrictions in e.g. autocomplete
 */
export class ShRecordRestrictionsResolverService {
    protected restrictionType: RestrictionType = RestrictionType.All;
    protected useParentId: boolean = false;
    protected publicOnly: boolean = false;

    protected ShRecordRestrictionService: ShRecordRestrictionService = inject(ShRecordRestrictionService);

    resolve(route: ActivatedRouteSnapshot): Observable<Restriction> {
        this.restrictionType = route.data['restrictionType'] ?? RestrictionType.All;
        this.useParentId = route.data['useParentId'] ?? false;
        this.publicOnly = route.data['publicOnly'] ?? false;

        let parentId: RecordId | null = this.useParentId ? this.getLastRecordIdParam(route) : null;

        return this.ShRecordRestrictionService.initialize({
            type: this.restrictionType,
            parentId,
            publicOnly: this.publicOnly
        });
    }

    protected getLastRecordIdParam(route: ActivatedRouteSnapshot): RecordId | null {
        const recordIds: RecordId[] = route.pathFromRoot
            .map(activatedRouteSnapshot => activatedRouteSnapshot.paramMap.get('recordId') ?? '')
            .filter((recordId: string) => recordId !== '')
            .map((recordId: string) => recordId.slice(0, 64)) as RecordId[]; // FragmentId to RecordId

        return recordIds.length > 0 ? recordIds[recordIds.length - 1] : null;
    }
}
